import { encode } from "js-base64";

/**
 * Update the data-target attribute with the referrer and facebook values.
 *
 * These values are also added on the backend. But needs to be overritten with js
 * to work with caching.
 */
function handleUpdateTargetReferrer() {
  const referrer = document.referrer;
  const targets = document.querySelectorAll<HTMLDivElement>("[data-target]");

  targets.forEach((target) => {
    const dataTarget = target?.dataset?.target;

    if (dataTarget != null) {
      const json = JSON.parse(atob(dataTarget));
      const newDataTarget = {
        ...json,
        referrer,
        facebook: referrer.includes("facebook.com").toString(),
      };

      target.setAttribute("data-target", encode(JSON.stringify(newDataTarget)));
    }
  });
}

document.addEventListener("DOMContentLoaded", handleUpdateTargetReferrer);
document.addEventListener("content-added", handleUpdateTargetReferrer);
